import type { Definition } from '@exodus/dependency-types';
import type { AddressProvider } from '@passkeys/address-provider';

type Dependencies = {
  config: { baseUrl: string };
  addressProvider: AddressProvider;
  fetch: typeof fetch;
};

const createAirdrop = ({ config, addressProvider, fetch }: Dependencies) => {
  const request = async (
    endpoint: `/${string}`,
    body: Record<string, unknown>,
  ) => {
    return fetch(`${config.baseUrl}${endpoint}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });
  };

  const claim = async ({
    campaignId,
    assetName,
    claimId,
  }: {
    campaignId: string;
    assetName: string;
    claimId: string;
  }) => {
    const receiveAddress = await addressProvider.getReceiveAddress({
      assetName,
    });

    const response = await request('/claim', {
      campaign: campaignId,
      address: receiveAddress.address,
      claimId,
    });

    return response.json();
  };

  return {
    claim,
  };
};

const airdropDefinition = {
  id: 'airdrop',
  type: 'module',
  factory: createAirdrop,
  dependencies: ['addressProvider', 'config', 'fetch'],
} as const satisfies Definition;

export type Airdrop = ReturnType<(typeof airdropDefinition)['factory']>;

export default airdropDefinition;
